import { api } from './client';

export interface Broker {
  id: string;
  name: string;
  referral_url: string;
  logo_url: string;
  is_active: boolean;
}

export interface BrokerPayload {
  name: string;
  referral_url: string;
  logo_url: string;
  is_active: boolean;
}

export async function fetchMemberBrokers(): Promise<Broker[]> {
  const { data } = await api.get<Broker[]>('/member/brokers');
  return data;
}

export async function adminListBrokers(): Promise<Broker[]> {
  const { data } = await api.get<Broker[]>('/admin/brokers');
  return data;
}

export async function adminCreateBroker(payload: BrokerPayload): Promise<Broker> {
  const { data } = await api.post<Broker>('/admin/brokers', payload);
  return data;
}

export async function adminUpdateBroker(id: string, payload: BrokerPayload): Promise<Broker> {
  const { data } = await api.put<Broker>(`/admin/brokers/${id}`, payload);
  return data;
}

export async function adminDeleteBroker(id: string): Promise<any> {
  const { data } = await api.delete(`/admin/brokers/${id}`);
  return data;
}
